var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoOld(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 198.21,
    height: 230.094,
    viewBox: "0 0 198.21 230.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video_old",
    transform: "translate(-0.07 0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.07 -0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 81.119,
    height: 9.909,
    transform: "translate(42.166 96.042)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 30.035,
    height: 36.843,
    transform: "translate(147.744 121.737)",
    fill: "#303d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 30.035,
    height: 4.954,
    transform: "translate(147.744 124.525)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M447.3,294.8c0,13.9-2.5,25.171-5.576,25.171S436.15,308.7,436.15,294.8s2.492-25.167,5.576-25.167S447.3,280.9,447.3,294.8Z",
    transform: "translate(-249.092 -153.967)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M254.356,47.492a47.491,47.491,0,1,0,0,.006Z",
    transform: "translate(-91.032 0.01)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M79,76.884a39.464,39.464,0,1,0-39.464,39.464A39.464,39.464,0,0,0,79,76.884Z",
    transform: "translate(-0.07 -21.364)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 33.287,
    cy: 33.287,
    r: 33.287,
    transform: "translate(6.128 88.769) rotate(-89.94)",
    fill: "#303d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M84.9,100.759A21.525,21.525,0,1,0,63.362,122.28,21.526,21.526,0,0,0,84.9,100.759Z",
    transform: "translate(-23.928 -45.24)",
    fill: "#fff",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M73.714,98.062a7.292,7.292,0,1,0-7.292,7.292A7.292,7.292,0,0,0,73.714,98.062Z",
    transform: "translate(-33.796 -51.83)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 82.977,
    height: 7.429,
    transform: "translate(40.309 96.042)",
    fill: "#303d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M256.408,55.732a41.3,41.3,0,1,0-41.3,41.3,41.306,41.306,0,0,0,41.3-41.3Z",
    transform: "translate(-99.278 -8.23)",
    fill: "#303d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M129.846,489.677h10.835v-35.1H129.846Zm27.938-35.1h-12.44l19.646,35.1h12.44Zm-64.913,35.1h12.44l19.852-35.1h-12.44Z",
    transform: "translate(-53.063 -259.582)",
    fill: "#303d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M260.921,73.88a27.68,27.68,0,1,0-27.68,27.68,27.68,27.68,0,0,0,27.68-27.68Z",
    transform: "translate(-117.415 -26.378)",
    fill: "#fff",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 82.977,
    height: 7.429,
    transform: "translate(40.309 96.042)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M177.153,307.373a6.194,6.194,0,0,1-6.194,6.211H56.51a6.19,6.19,0,0,1-6.19-6.19V247.35a6.19,6.19,0,0,1,6.19-6.19H170.959a6.194,6.194,0,0,1,6.194,6.19Z",
    transform: "translate(-28.765 -137.71)",
    fill: "#303d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M159.467,191.384a47.79,47.79,0,0,1-40.545-22.524A39.777,39.777,0,0,1,76.37,190.8v3.972h96.218v-5.216A47.7,47.7,0,0,1,159.467,191.384Z",
    transform: "translate(-43.641 -96.423)",
    fill: "#303d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 12.461,
    height: 39.352,
    transform: "translate(153.359 120.759)",
    fill: "#303d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M421.629,314.249a3.1,3.1,0,0,1-4.719,2.629l-16.48-10.2V267.33l16.48-10.2a3.1,3.1,0,0,1,4.719,2.634Z",
    transform: "translate(-228.695 -146.572)",
    fill: "#303d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M188.348,423.131a6.194,6.194,0,0,1-6.194,6.194H139.43a6.19,6.19,0,0,1-6.19-6.194V418.49h55.108Z",
    transform: "translate(-76.116 -238.973)",
    fill: "#303d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 55.112,
    height: 5.057,
    transform: "translate(57.124 179.517)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M233.913,313.357a3.054,3.054,0,0,1-3.221,2.853h0a3.062,3.062,0,0,1-3.221-2.853v-35.11a3.057,3.057,0,0,1,3.221-2.857h0a3.06,3.06,0,0,1,3.221,2.857Z",
    transform: "translate(-129.926 -157.256)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M206.183,330.888a3.054,3.054,0,0,1-3.221,2.853h0a3.06,3.06,0,0,1-3.221-2.853V308.943a3.054,3.054,0,0,1,3.221-2.853h0a3.06,3.06,0,0,1,3.221,2.853Z",
    transform: "translate(-114.091 -174.788)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M178.423,342.571a3.054,3.054,0,0,1-3.221,2.853h0a3.06,3.06,0,0,1-3.221-2.853V329.4a3.054,3.054,0,0,1,3.221-2.853h0a3.06,3.06,0,0,1,3.221,2.853Z",
    transform: "translate(-98.239 -186.471)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M150.717,354.261a3.058,3.058,0,0,1-3.226,2.853h0a3.062,3.062,0,0,1-3.221-2.853v-4.388a3.054,3.054,0,0,1,3.221-2.853h0a3.064,3.064,0,0,1,3.226,2.853Z",
    transform: "translate(-82.415 -198.161)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M400.4,285.1l21.212-5.98V270.53L400.4,279.658Z",
    transform: "translate(-228.677 -154.481)",
    fill: "#fff",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 12.461,
    height: 5.572,
    transform: "translate(153.359 125.953)",
    fill: "#fff",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M178.82,249.637a4.337,4.337,0,0,1-4.337,4.332H61.167a4.337,4.337,0,0,1-4.337-4.332h0a4.337,4.337,0,0,1,4.337-4.337H174.483A4.337,4.337,0,0,1,178.82,249.637Z",
    transform: "translate(-32.483 -140.074)",
    fill: "#fff",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M174.072,325.329H67.876a3.106,3.106,0,0,1-3.1-3.1V284.458a4.337,4.337,0,0,0-8.669,0v45.2A4.337,4.337,0,0,0,60.447,334H174.072a4.337,4.337,0,1,0,0-8.669Z",
    transform: "translate(-32.072 -160.036)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M453.423,282.768c0,2.222-.429,4.024-.927,4.024s-.927-1.8-.927-4.024.429-4.028.927-4.028S453.423,280.542,453.423,282.768Z",
    transform: "translate(-257.898 -159.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M245.494,66.292a7.292,7.292,0,1,0-7.292,7.292A7.292,7.292,0,0,0,245.494,66.292Z",
    transform: "translate(-131.891 -33.688)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M168.251,454.58h-8.922l19.646,35.1h3.56Zm-50.891,35.1H119.3l19.852-35.1h-7.146Z",
    transform: "translate(-67.048 -259.582)",
    opacity: 0.2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOld);
export default __webpack_public_path__ + "static/media/video_old.2c8bca9cd7aaf79d5f8aa50709ad9e40.svg";
export { ForwardRef as ReactComponent };